import fetchServer from "../../../fetchServer";

/**
 * Confirm a submitted bank-transfer proof for a change request.
 * PATCH /product/v1/changeBooking/bankTransferProof/:id/confirm
 * body: { proofId, amount }
 */
export default async function confirmChangeBankTransferProof(changeId, data) {
  var result = { return: 0, msg: "Failed confirming bank transfer", data: [] };

  await fetchServer({
    method: "PATCH",
    url: `/product/v1/changeBooking/bankTransferProof/${changeId}/confirm`,
    data,
  })
    .then((res) => {
      if (res) {
        if (res.status >= 200 && res.status < 300) {
          result = {
            return: 1,
            msg: "Successful",
            data: res?.data?.data ?? res?.data,
          };
        } else if (res?.data?.error) result["msg"] = res.data.error;
        else if (res?.error) result["msg"] = res.error;
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
